export default __webpack_public_path__ + "static/media/2100-00 to 2105-00.33455f2b.jpg";